import ReviewsStoreBase from "@apps/reviews/stores/ReviewsStoreBase";
import { StoreConfig } from "@datorama/akita";
import { injectable } from "tsyringe";

@injectable()
@StoreConfig({ name: "customer_reviews_widget_site_reviews_store" })
class SiteReviewsStore extends ReviewsStoreBase {}

export default SiteReviewsStore;
